import type { Distance, Rectangle } from "@pdfking/math"
import { Ceil, Max } from "@pdfking/math"
import { ZERO_MARGINS, ZERO_POINT, ZERO_RECTANGLE } from "@pdfking/math/constants"
import { MM } from "@pdfking/quantity"
import type { PageNumber } from "@pdfking/renderer-api"
import { ContentRenderer } from "@pdfking/templates"

import type { Meta3D } from "#public"

import { BuildBookBlock } from "../common/BuildBookBlock"

// Depth of one sheet in the synthesized pass-through book — enough to read as a
// stack without the spine dominating the model.
const SHEET_DEPTH = MM(0.1)

// The pass-through book: one block of plain sheets sized like the first page.
// There is no imposed book to describe, so it's synthesized over the pages.
export const CreateFilesBook = (pages: Rectangle<Distance>[]): Meta3D["book"] => {
  const { width, height } = pages[0] ?? ZERO_RECTANGLE
  const sheets = Max(1, Ceil(pages.length / 2)) as PageNumber
  return {
    blocks: [
      BuildBookBlock({
        print_front: true,
        print_rear: true,
        sheets,
        width,
        height,
        depth: (sheets * SHEET_DEPTH) as Distance,
        renderer: ContentRenderer.BOOK,
        is_cover: false,
        security: ZERO_MARGINS,
      }),
    ],
    blocks_offset: ZERO_POINT,
    opening_axis: "x",
  }
}
